import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environment";
import { Observable } from "rxjs";
import {
  TimeCardDetailRowEdit,
  UserTimeCardResponse,
} from "../interfaces/time-card.interfaces";
import { sanitizeParams } from "../sanitize-params";

@Injectable({ providedIn: "root" })
export class TimeDetailClient {
  endpoint = "usertimecard";

  constructor(private httpClient: HttpClient) {}

  get(filters: {
    userId: string;
    facilityId?: string;
    date: string;
  }): Observable<UserTimeCardResponse> {
    const params = sanitizeParams(filters) as Record<string, any>;

    return this.httpClient.get<UserTimeCardResponse>(
      `${environment.endpoint}/${this.endpoint}/get`,
      { params }
    );
  }

  edit(data: TimeCardDetailRowEdit[]) {
    return this.httpClient.put<TimeCardDetailRowEdit[]>(
      `${environment.endpoint}/${this.endpoint}/edit`,
      data
    );
  }

  addTimeCardFacilities(
    data: { userid: string; facilityid: string; timecarddate: string }[]
  ): Observable<any> {
    return this.httpClient.put<any>(
      `${environment.endpoint}/${this.endpoint}/add-user-timecard-facilities`,
      data
    );
  }

  getTimeCardFacilities(data: { userid: string; timecarddate: string }) {
    const params = sanitizeParams(data) as Record<string, any>;

    return this.httpClient.get<any>(
      `${environment.endpoint}/${this.endpoint}/get-user-timecard-facilities`,
      { params }
    );
  }

  getIncompleteTimeCards(userId: string): Observable<string[]> {
    const paramKey = "userId";
    const params = new HttpParams().set(paramKey, userId);
    const actionName = "get-incomplete";
    const url = `${environment.endpoint}/${
      this.endpoint
    }/${actionName}?${params.toString()}`;
    return this.httpClient.get<string[]>(url);
  }
}
